import { Box, Container, Typography, Link, Stack } from '@mui/material';
import NextLink from 'next/link';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        bgcolor: 'secondary.main',
        color: 'primary.contrastText',
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={2} alignItems="center">
          <Typography variant="body2" align="center">
            Copyright 2019 - {currentYear} - Extensive Rewards. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={2}>
            <Link component={NextLink} href="/terms" color="primary.contrastText" underline="hover">
              Terms & Conditions
            </Link>
            <Link component={NextLink} href="/privacy" color="primary.contrastText" underline="hover">
              Privacy Policy
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}